import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { AngularMaterialModule } from './angular-material.module';
import { AccountThemeService } from './services/account-theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [FormsModule,AngularMaterialModule , ReactiveFormsModule, RouterOutlet, CommonModule],  // Add CommonModule
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'societyxpertAPP';
  private readonly accountTheme = inject(AccountThemeService);

  ngOnInit(): void {
    this.accountTheme.applyFromSession();
  }

  onActivate() {
    window.scroll(0, 0);
  }
}
